import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const CacheContext = createContext(null);

export function CacheProvider({ children }) {
  const [cacheState, setCacheState] = useState(null);
  const registryRef = useRef({});
  const activeKeyRef = useRef(null);

  const updateDisplay = useCallback(() => {
    const key = activeKeyRef.current;
    const entry = key && registryRef.current[key];
    if (entry) {
      setCacheState(entry);
    } else {
      // Fallback to last registered if active key not found
      const keys = Object.keys(registryRef.current);
      if (keys.length > 0) {
        setCacheState(registryRef.current[keys[keys.length - 1]]);
      } else {
        setCacheState(null);
      }
    }
  }, []);

  const registerCache = useCallback((key, state) => {
    registryRef.current[key] = state;
    updateDisplay();
  }, [updateDisplay]);

  const unregisterCache = useCallback((key) => {
    delete registryRef.current[key];
    updateDisplay();
  }, [updateDisplay]);

  const setActiveCacheKey = useCallback((key) => {
    activeKeyRef.current = key;
    updateDisplay();
  }, [updateDisplay]);

  return (
    <CacheContext.Provider value={{ cacheState, registerCache, unregisterCache, setActiveCacheKey }}>
      {children}
    </CacheContext.Provider>
  );
}

export function useCacheContext() {
  return useContext(CacheContext);
}
